import React, { useEffect, useState } from "react";
import userStore from "../Stores/User";
import { Redirect } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { createDrawaboxCheckoutSession } from "../audiblogsApi";
import { observer } from "mobx-react";
import loading from "../Assets/loading.gif";

const STRIPE_API_KEY = process.env.REACT_APP_STRIPE_API_KEY;
const stripePromise = loadStripe(STRIPE_API_KEY);
const Drawabox = observer((props) => {
  useEffect(() => {
    if (userStore.user) {
      if (userStore.user.subscribed_to_drawabox) {
      } else {
        console.log("signed ind");
        stripePromise.then((stripe) => {
          console.log("creating a stripe session now");
          createDrawaboxCheckoutSession(userStore.idToken).then(function (
            data
          ) {
            // Call Stripe.js method to redirect to the new Checkout page
            console.log("session: " + data.sessionId);
            stripe
              .redirectToCheckout({
                sessionId: data.sessionId,
              })
              .then((handleResult) => {
                handleResult();
              });
          });
        });
      }
    }
  }, [userStore.user]);
  return (
    <div className="center">
      {userStore.user && userStore.user.subscribed_to_drawabox ? (
        <div>
          <h1 className="subheadline">You're subscribed!</h1>
          <a href="https://drawabox.com/lessons">Open Drawabox</a>
        </div>
      ) : (
        <div>
          <h1 className="subheadline">Redirecting...</h1>
          <img src={loading} />
        </div>
      )}
    </div>
  );
});

export default Drawabox;
